/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateReportConfigResponse } from './UpdateReportConfigResponse';
import {
    UpdateReportConfigResponseFromJSON,
    UpdateReportConfigResponseFromJSONTyped,
    UpdateReportConfigResponseToJSON,
    UpdateReportConfigResponseToJSONTyped,
} from './UpdateReportConfigResponse';

/**
 * 
 * @export
 * @interface ResultOfUpdateReportConfigResponse
 */
export interface ResultOfUpdateReportConfigResponse {
    /**
     * 
     * @type {UpdateReportConfigResponse}
     * @memberof ResultOfUpdateReportConfigResponse
     */
    data: UpdateReportConfigResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfUpdateReportConfigResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfUpdateReportConfigResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfUpdateReportConfigResponse interface.
 */
export function instanceOfResultOfUpdateReportConfigResponse(value: object): value is ResultOfUpdateReportConfigResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfUpdateReportConfigResponseFromJSON(json: any): ResultOfUpdateReportConfigResponse {
    return ResultOfUpdateReportConfigResponseFromJSONTyped(json, false);
}

export function ResultOfUpdateReportConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfUpdateReportConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': UpdateReportConfigResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfUpdateReportConfigResponseToJSON(json: any): ResultOfUpdateReportConfigResponse {
    return ResultOfUpdateReportConfigResponseToJSONTyped(json, false);
}

export function ResultOfUpdateReportConfigResponseToJSONTyped(value?: ResultOfUpdateReportConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UpdateReportConfigResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

